<template>
  <div class="about">
		<div class="pg-header">
			<div>
				<label class="title">患者列表</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>患者管理</span>|
					<span class="active">患者列表</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap" :class="{active: isExpanded}">

			<div class="search-bar">
				<el-form ref="form" label-width="140px">
				<div class="def-key">
					<label>姓名<el-input size="small" placeholder="姓名" maxlength="6" style="width:80px" v-model.trim="filter.name" @keyup.enter.native="handleFilter('search')"></el-input></label>
					<label>身份证号<el-input size="small" placeholder="身份证号" maxlength="18" style="width:160px" v-model.trim="filter.cardNum" @keyup.enter.native="handleFilter('search')"></el-input></label>
					<label>联系电话<el-input size="small" placeholder="联系电话" maxlength="11" style="width:120px" v-model="filter.phone" @keyup.enter.native="handleFilter('search')"></el-input></label>
					<el-button size="mini" icon="el-icon-search" round  @click="handleFilter('search')">搜索</el-button>
					
					<el-button class="btn-collapse flr" size="mini" round @click="toggleCollapse" v-if="!isExpanded">展开筛选<i class="icon-expand"></i></el-button>
					<el-button class="btn-collapse flr" size="mini" round @click="toggleCollapse" v-else>收起筛选<i class="icon-collapse"></i></el-button>
				</div>
				<div class="more-key">
					<el-form-item label="性别">						
						<span class="key-opt" :class="{active: filter.sex == 1}" @click="handleFilter('sex', 1)">男<i class="el-icon-close"></i></span>
						<span class="key-opt" :class="{active: filter.sex == 2}" @click="handleFilter('sex', 2)">女<i class="el-icon-close"></i></span>
					</el-form-item>
					<el-form-item label="年龄">
						<el-input size="small" maxlength="3" style="width:60px" v-model.number="filter.ageStart"></el-input>-<el-input size="small" maxlength="3" style="width:60px" v-model.number="filter.ageEnd"></el-input>岁
						<el-button style="margin-left: 20px;" size="mini" round plain @click="handleFilter('age')">确定</el-button>
					</el-form-item>
					<el-form-item label="疾病标签">
						<template v-for="item in tagDisease">
						<span :key="item.tagId" class="key-opt" :class="{active: filter.diseaseTag.indexOf(item.tagId) > -1}" @click="handleFilter('diseaseTags', item.tagId)">{{item.tagName}}<i class="el-icon-close"></i></span>
						</template>
					</el-form-item>
					<el-form-item label="疾病标签关系">
						<el-radio-group v-model="filter.diseaseTagRelation" @change="handleFilter()">
							<el-radio :label="1">且</el-radio>
							<el-radio :label="2">或</el-radio>
						</el-radio-group>
					</el-form-item>	
					<el-form-item label="生活方式标签">
						<template v-for="item in tagLife">
						<span :key="item.tagId" class="key-opt" :class="{active: filter.lifeTag.indexOf(item.tagId) > -1}" @click="handleFilter('lifeTags', item.tagId)">{{item.tagName}}<i class="el-icon-close"></i></span>
						</template>
					</el-form-item>
					<el-form-item label="生活方式标签关系">
						<el-radio-group v-model="filter.lifeTagRelation" @change="handleFilter()">
							<el-radio :label="1">且</el-radio>
							<el-radio :label="2">或</el-radio>
						</el-radio-group>
					</el-form-item>	
					<el-form-item label="星级客户">
						<span class="key-opt" :class="{active: filter.star == 1}" @click="handleFilter('star', 1)">重点关注<i class="el-icon-close"></i></span>
					</el-form-item>					
				</div>
				</el-form>
			</div>

			
			<div class="table-wrap">
				<div class="action-bar">
					<el-button type="primary" size="mini" round @click="showDlg(1)">保存到组</el-button>
					<!-- <el-button type="primary" size="mini" round>发问卷</el-button> -->
					<!-- <el-button type="primary" size="mini" round @click="showDlg(3)">发短信</el-button> -->
					<el-button type="primary" size="mini" round @click="handleFav">重点关注</el-button>
					<el-button type="primary" size="mini" v-if="addPatientRule" round @click="showDlg(4)">添加患者</el-button>

				</div>
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column fixed="left" type="selection" width="55"></el-table-column>    
					<el-table-column fixed="left" prop="name" label="姓名" width="120">
						<template slot-scope="scope"><router-link class="noline" target="_blank"  :to="{name: 'Patient/User', query: {patientId: scope.row.id}}"><span class="fc key">{{ scope.row.name }}</span></router-link></template>
					</el-table-column>
					<el-table-column label="性别">
						<template slot-scope="scope">{{ scope.row.sex == '2' ? '女' : '男' }}</template>
					</el-table-column>
					<el-table-column prop="age" label="年龄" width="80">
						<template slot-scope="scope">
							<span>{{scope.row.age}}岁</span>
						</template>
					</el-table-column>
					<el-table-column prop="cardTypeStr" label="证件类型"></el-table-column>
					<el-table-column prop="idcard" label="证件号码" width="180"></el-table-column>
					<el-table-column prop="phone" label="本人电话" width="180"></el-table-column>
					<el-table-column prop="date" label="更新时间" width="200"></el-table-column>
					<el-table-column fixed="right" label="操作" width="220">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank"  :to="{name: 'Patient/User', query: {patientId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>
								<!-- <el-tooltip content="电话" placement="top" :enterable="false"><i class="icon-tel" @click="call(scope.row)"></i></el-tooltip> -->
								<!-- <el-tooltip content="电话" placement="top" :enterable="false"><i class="icon-tel" @click="copyMobile(scope.row)"></i></el-tooltip> -->
								<el-tooltip content="短信" placement="top" :enterable="false"><i class="icon-msg" @click="showDlg(3, scope.row)"></i></el-tooltip>
								<!-- <el-tooltip content="在线沟通" placement="top" :enterable="false"><i class="icon-chat"></i></el-tooltip> -->
								<el-tooltip content="取消重点关注" placement="top" :enterable="false" v-if="scope.row.star == 1"><i class="icon-fav" @click="handleFav(scope.$index, scope.row)"></i></el-tooltip>
								<el-tooltip content="重点关注" placement="top" :enterable="false" v-else><i class="icon-fav-no" @click="handleFav(scope.$index, scope.row)"></i></el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>	
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>			
		</div>

		<el-dialog title="保存到组" width="800px" :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="180px" :rules="dlg.rules" :model="form2">
				<el-form-item label="保存到" prop="groupId">
					<el-select size="small" filterable v-model="form2.groupId" placeholder="分组">
						<el-option v-for="item in groupList" :key="item.id" :label="item.groupingName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg(1)">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm(1)">保 存</el-button>
			</div>
		</el-dialog>
				
		<el-dialog title="发短信" label-position="left" width="800px" :visible.sync="dlg.active3" :close-on-click-modal="false">
			<el-form ref="form3" :rules="dlg.rules3" :model="form3">
				<el-form-item label="接收人:"><div class="to-users">{{form3.users}}</div></el-form-item>
				<el-form-item label="" label-width="0" prop="content">
					<el-input type="textarea" style="width: 100%;" rows="6" resize="none" maxlength="255" placeholder="请输入短信内容,最多255个字" show-word-limit v-model="form3.content"></el-input>
					<div v-if="smsFlag">计费条数:&nbsp;{{Math.ceil(form3.content.length/smsPrice)}}条&nbsp;&nbsp;({{ smsPrice }}字/条)</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg(1)">取 消</el-button>
				<el-button type="primary" @click="saveForm3" v-if="!isLoading">发 送</el-button>
				<el-button type="primary" :loading="true" v-else>发送中</el-button>				
			</div>
		</el-dialog>				
		<el-dialog :title="addPatientTitle" width="640px" :visible.sync="dlg.active4" :close-on-click-modal="false" class='addPatientDialog' @close="closeDlg">
			<div class="repeatCon" v-if="dialogState==3">
				<p style="color: #FF0000;">该患者在系统中已存在</p>
				<el-table header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="repeatList" v-loading="isLoading" :header-cell-style="{background:'#f5f7fa'}">
					<el-table-column fixed="left" prop="name" label="姓名">
						<template slot-scope="scope"><router-link class="noline" target="_blank"  :to="{name: 'Patient/User', query: {patientId: scope.row.id}}"><span class="fc key">{{ scope.row.name }}</span></router-link></template>
					</el-table-column>
					<el-table-column prop="cardNum" label="身份证号" ></el-table-column>
					<el-table-column fixed="right" label="操作">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank"  :to="{name: 'Patient/User', query: {patientId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>	
			</div>
			<div v-else-if='dialogState==4'>
				<p style="text-align: center; color: #FF0000;">该患者证件号码校验未通过</p>
				<p style="text-align: center; "> 请与患者确认正确的证件号码</p>
			</div>
			<div v-else-if='dialogState==5'>
				<p style="text-align: center; ">是否添加就诊记录？</p>
			</div>
			<template v-else>
				<el-form ref="form4" label-width="180px" :rules="dlg.rules4" :model="form4">
					<div class="stepline" >基础信息</div>
					<el-form-item label="患者姓名" prop="name" >
						<el-input size="small" v-model.trim="form4.name" maxlength="20" :disabled="vaildateDisabled" placeholder="请输入患者姓名"></el-input>
					</el-form-item>
					<el-form-item label="证件类型" prop="cardType">
					<el-select size="small" v-model="form4.cardType" placeholder="请选择证件类型" :disabled="vaildateDisabled">
						<el-option label="身份证" value="1"></el-option>
						<el-option label="护照" value="2"></el-option>
					</el-select>
					</el-form-item>
					<el-form-item label="证件号码" prop="cardNum">
						<el-input size="small" v-model.trim="form4.cardNum" :maxlength="form4.cardType === '1' ? 18 : 20" :disabled="vaildateDisabled" placeholder="请输入证件号码"></el-input>
					</el-form-item>
					<el-form-item label="患者本人手机号" prop="phone"  v-if="dialogState==2">
							<el-input size="small" v-model.trim="form4.phone" maxlength="20" placeholder="请输入患者本人手机号"></el-input>
					</el-form-item>
					<template v-if="dialogState==2">
						<template v-if="form4.cardType === '2'">
							<el-form-item label="患者性别" prop="sex">
								<el-radio-group v-model="form4.sex">
								<el-radio label="1">男</el-radio>
								<el-radio label="2">女</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="患者年龄" prop="age">
								<el-input size="small" v-model.number="form4.age" maxlength="3" placeholder="请输入患者年龄"></el-input>
							</el-form-item>
						</template>
						<div class="stepline" >亲属信息</div>

						<el-form-item label="患者亲属姓名">
							<el-input size="small" v-model.trim="form4.relativesName" maxlength="20" placeholder="请输入患者亲属姓名"></el-input>
						</el-form-item>
						<el-form-item label="关系">
							<el-select size="small" v-model="form4.relativesRelationship" placeholder="请选择关系">
								<el-option v-for="(item,index) in patientRelationship"  :label="item.label" :value="item.value" :key="index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="亲属电话">
							<el-input size="small" v-model.trim="form4.relativesPhone" maxlength="11" placeholder="请输入亲属电话"></el-input>
						</el-form-item>
					</template>
				</el-form>
			</template>
			<div slot="footer" class="dialog-footer addFooter">
				<el-button type="primary" v-if='dialogState==1' :loading="isLoading" @click="validateForm4">验 证</el-button>
				<el-button type="primary" v-if='dialogState==2'  :loading="isLoading" @click="addPatientHandle">提 交</el-button>
				<el-button type="primary" v-if='dialogState==5'  :loading="isLoading" @click="toAddPatientRecord">添 加</el-button>
				<el-button v-if='dialogState==2||dialogState==5' :loading="isLoading" @click="closeDlg(1)">取 消</el-button>
				<el-button v-if='dialogState==3||dialogState==4' :loading="isLoading" @click="goBack">返 回</el-button>

			</div>
		</el-dialog>
  </div>
</template>

<script>
import api from '@/service/api.js';
import utils from '@/service/utils';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

export default {
  mixins: [mixin],
	data(){
		return {
			isExpanded: false,
			dlg: {
				active: false,
				active3: false,
				rules: {
					groupId: {required: true, message: '请选择分组'}
				},
				rules3: {
					content: {required: true, message: '请输入内容'}
				},
				active4:false,
				rules4: {
					name: [
						{ required: true, message: '请输入患者姓名', trigger: 'blur' },
						{ max: 20, message: '姓名长度不能超过20个字符', trigger: 'blur' }
					],
					
					cardType: [
						{ required: true, message: '请选择证件类型', trigger: 'change' }
					],
					cardNum: [
						{ required: true, message: '请输入证件号码', trigger: 'blur' },
						{ validator: this.validatecardNum, trigger: 'blur' }
					],
					phone:[
					{ required: true, message: '请输入患者手机号', trigger: 'blur' },
					],
					sex: [
						{ required: true, message: '请选择患者性别', trigger: 'change' }
					],
					age: [
							{ required: true, message: '请输入患者年龄', trigger: 'blur' },
						],
				},
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				cardNum: '',
				phone: '',
				sex: '',
				ageStart: '',
				ageEnd: '',
				star: '',
				diseaseTag: '',
				lifeTag: '',
				diseaseTagIds: '',
				lifeTagIds: '',
				diseaseTagRelation:1,
				lifeTagRelation:1,
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				groupingName: '',
				description: ''
			},
			form2: {
				groupId: '',
				patientIds: []
			},
			// 短信表单
			form3: {
				users: '',
				content: '',
				shortMessageSendListPos: []
			},
			groupList: [],
			tagDisease: [],
			tagLife: [],
			smsPrice:50,
			smsFlag:false,
			form4: {
				name: '',
				cardType: '1', // 1-身份证 2-护照3 其他
				cardNum: '',
				relativesName: '', 
				relativesPhone: '', 
				relativesRelationship: '', 
				sex: '',
				age: '',
				phone:null
			},
			dialogState:1,//1验证 2保存 3重复患者 4校验未通过 5跳转至添加记录
			addPatientRule:false,
			newPatient:{},
			repeatList:[],
			vaildateDisabled:false,
			addPatientTitle:'添加患者'
		}	
	},
	async created() {
		let query = this.$route.query;
		if (query) {
			this.filter.name = query.name || '';
			this.filter.cardNum = query.cardNum || '';
			this.filter.phone = query.phone || '';
			this.filter.sex = query.sex || '';
			this.filter.star = query.star || '';
			this.filter.ageStart = query.ageStart || '';
			this.filter.ageEnd = query.ageEnd || '';
			
			//疾病标签初始化
			this.filter.diseaseTag = query.diseaseTagIds ? query.diseaseTagIds.split(',') : [];
			this.filter.diseaseTag = this.filter.diseaseTag.map((item)=>{ return +item;});
			this.filter.diseaseTagIds = this.filter.diseaseTag.join(',');
			//生活方式标签初始化
			this.filter.lifeTag = query.lifeTagIds ? query.lifeTagIds.split(',') : [];
			this.filter.lifeTag = this.filter.lifeTag.map((item)=>{ return +item;});
			this.filter.lifeTagIds = this.filter.lifeTag.join(',');
		}
		this.init()
		
	},
	methods: {
		async init(){
			this.loadList();

			let res = await api.getSysRule();
			if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
			this.addPatientRule= res.data.add_patient.enable==1;
			this.smsFlag=await api.getSmsFlag();
			if(this.smsFlag){
				this.smsPrice=JSON.parse(localStorage.getItem('smsInfo'))?.smsPrice;
			}
			api.getPatientGroupList({}).then((res)=>{
				if (res.code == 1000 && res.data) {
					this.groupList = res.data;
				}
			});
			
			api.getPatientAllTag().then((res)=>{
				if (res.code == 1000 && res.data) {
					this.tagDisease = res.data.diseaseTagList;
					this.tagLife = res.data.lifeTagList;
				}
			});

		},
		validatecardNum(rule, value, callback) {
			if (!value) {
			callback(new Error('请输入证件号码'));
			return;
			}
			
			if (this.form4.cardType === '1') {
			// 身份证号码验证
			const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
			if (!reg.test(value)) {
				callback(new Error('请输入正确的身份证号码'));
				return;
			}
			} else if (this.form4.cardType === '2') {
			// 护照号码验证 - 简单格式验证
			const reg = /^[a-zA-Z0-9]{5,20}$/;
			if (!reg.test(value)) {
				callback(new Error('请输入正确的护照号码'));
				return;
			}
			}
			callback();
		},
		goBack(){
			this.dialogState=1;
			this.vaildateDisabled=false;
			this.addPatientTitle='添加患者'

		},
		validateForm4(){
			// this.dialogState=2;
			// 		console.log(this.form4,'---ff');
			this.$refs.form4.validate(async(valid) => {
				if(valid){
					let res=await api.checkAddPatientParam(this.form4);
					if(res.code== 1005){
						this.dialogState=4;
						this.addPatientTitle='添加失败'

					}else if(res.code== 1000){
						this.dialogState=2;
						this.vaildateDisabled=true
					}else if(res.code== 1006){
						this.dialogState=3;
						this.repeatList=res.data;
						this.addPatientTitle='添加失败'
					}
					console.log(res,'=======res');
				}
			})
		},
		addPatientHandle(){
			this.$refs.form4.validate(async (valid) => {
					if(valid){
						let res=await api.addPatient(this.form4);
						if(res.code== 1000){
							this.dialogState=5;
							this.newPatient=res.data;
							this.addPatientTitle='温馨提示'
							this.loadList();
						}
					}
				})
		},
		selectionChange(selected) {
			// 覆盖掉通用的
			let selection = []
			selected.forEach((item)=>{
				selection.push(item);
			})
			this.multipleSelection = selection;
		},		
		async loadList() {
			this.isLoading = true;
			let res = await api.getPatientList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
					item.idcard = utils.hideIdCard(item.cardNum);
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},		
		showDlg(v, item) {
			switch(v) {
				case 1:
					if (this.multipleSelection.length == 0) {return this.$message.warning('未选择任何数据');}
					this.dlg.active = true; 
					break;
				case 3:
					if (!item && this.multipleSelection.length == 0) {return this.$message.warning('未选择任何数据');}
					this.form3.content = '';
					if (item) {
						this.form3.shortMessageSendListPos = [{patientId: item.id, phone: item.phone}];
						this.form3.users = item.name;
					} else {
						let list = [];
						this.multipleSelection.forEach(item=>{
							list.push({patientId: item.id, phone: item.phone});
						})
						this.form3.shortMessageSendListPos = list;
						this.form3.users = this.multipleSelection.map(item=>item.name).join(', ')
					}
					this.dlg.active3 = true;
					this.$nextTick(()=>{
						this.$refs['form3'].resetFields();
					});
					break;
				case 4:
					this.dlg.active4 = true;
					this.vaildateDisabled=false;
					this.addPatientTitle='添加患者'
					if(this.dialogState==1){
						this.$nextTick(() => {
							Object.keys(this.form4).forEach(key => {
								this.form4[key] = '';
								});
								this.form4.cardType='1';
						});
					}
				break;

			}
		},
		closeDlg() {
			this.dlg.active = false;
			this.dlg.active3 = false;
			this.dlg.active4 = false;
			this.addPatientTitle='添加患者'
			this.dialogState=1;
		},
		async saveForm(v) {
			let res;
			switch(v) {
				case 1:
					this.isLoading = true;
					this.form2.patientIds = this.multipleSelection.map(item=>item.id).join(',');
					res = await api.addPatientToGroup(this.form2);
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('保存成功');
					this.isLoading = false;
					this.dlg.active = false;
					this.clearSelection();
					break;
			}
		},
		async saveForm3() {
			this.$refs['form3'].validate(async (valid)=>{
				if (valid) {
					this.isLoading = true;
					let res = await api.sendSMS(this.form3);
					this.isLoading = false;
					if (res.code != 1000) {return this.$message.error(res.message);}
					this.$message.success('短信发送成功');
					this.closeDlg();
					this.clearSelection();
				}
			})
		},
		/** 重点关注 **/
		async handleFav(idx, item) {
			let res;
			if (this.isLoading) { return;}
			if (!item && this.multipleSelection.length == 0) {return this.$message.warning('未选择任何数据');}
			this.isLoading = true;
			if (item) {
				res = await api.addPatientToStar({star: +!item.star, patientIds: item.id});
				if (res.code != 1000) {
					this.isLoading = false;
					return this.$message.error(res.message);
				}
			} else {
				res = await api.addPatientToStar({star: 1, patientIds: this.multipleSelection.map(item=>item.id).join(',')});
				if (res.code != 1000) {
					this.isLoading = false;
					return this.$message.error(res.message);
				}
			}
			this.isLoading = false;
			this.loadList();
		},
		/** 筛选状态切换 **/
		toggleCollapse() {
			this.isExpanded = !this.isExpanded;
		},
		/** 筛选 **/
		handleFilter(key, val) {
			let query;
			switch(key) {
				case 'sex':
					if (this.filter.sex == val) {this.filter.sex = '';} else {this.filter.sex = val;}
					break;
				case 'star':
					if (this.filter.star == val) {this.filter.star = '';} else {this.filter.star = val;}
					break;
				case 'diseaseTags':
					if (this.filter.diseaseTag.indexOf(val) > -1) {
						this.filter.diseaseTag.splice(this.filter.diseaseTag.indexOf(val), 1);
					} else {
						this.filter.diseaseTag.push(val);
					}
					break;
				case 'lifeTags':
					if (this.filter.lifeTag.indexOf(val) > -1) {
						this.filter.lifeTag.splice(this.filter.lifeTag.indexOf(val), 1);
					} else {
						this.filter.lifeTag.push(val);
					}
					break;
				case 'diseaseTagRelation':
					if (this.filter.diseaseTagRelation == val) {this.filter.diseaseTagRelation = '';} else {this.filter.diseaseTagRelation = val;}
					break;
				case 'lifeTagRelation':
					if (this.filter.lifeTagRelation == val) {this.filter.lifeTagRelation = '';} else {this.filter.lifeTagRelation = val;}
					break;
				case 'search':break;
				
			}
			query = JSON.parse(JSON.stringify(this.filter));
			query.diseaseTagIds = query.diseaseTag.join(',');
			query.lifeTagIds = query.lifeTag.join(',');
			delete query.pageNumber;
			delete query.pageSize;
			delete query.diseaseTag;
			delete query.lifeTag;
			this.$router.push({name: 'Patient/List', query: query});
			this.filter.diseaseTagIds = query.diseaseTagIds;
			this.filter.lifeTagIds = query.lifeTagIds;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		/** 打电话 **/
		async call(item){
			if(!item.phone) return false;
			this.isLoading = true;
			let res = await api.makePhoneCall(item.phone);
			if(res == "copyMobile"){
				this.copyMobile(item.phone);
				this.isLoading = false;
				return;
			} else if(res=='YS_HM4'){
				this.isLoading = false;   
				let info={
						patientId: item.id,
						relationship:0
				}
				console.log(info,item.phone,'------list-call');
				this.makeCall(item.phone,info);
			} else if(res=='SD_ZQ1'||res=='ZJ_SC1'){
				this.makeCall(item.phone);
				this.isLoading = false;
				// this.$message.success('电话呼出成功');
			} else if(!res){
				this.isLoading = false;
				this.$message.error('电话呼出失败');
			}
				
		},
		copyMobile(item) {
			this.$clipboard(item.phone);
			this.$message.success('手机号码复制成功');
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		toAddPatientRecord(){
			this.dlg.active4=false
			window.open(`#/patient/user?patientId=${this.newPatient.id}&t=3`, "_blank");
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
.stepline{
	color: #699CE4;
	border-bottom: 1px dashed #699CE4 ; //虚线
	margin:0 30px 20px;
}
.addFooter{
	button{
		padding:7px 16px 4px;;
		font-size: 14px;
		border-radius: 10px;
		border: 1px solid #699CE4;
		color: #699CE4;

	}
	::v-deep .el-button--primary{
		color:#fff;
	}
}
::v-deep .tab-cell{
	text-align: center !important;
}
.repeatCon{
	p{
		text-align:center;
		margin-bottom:20px;

	}
}
.to-users {
	width: 500px;
	height: 40px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
.addPatientDialog{
	::v-deep .el-dialog__header{
		text-align: center;
		font-size: 24px;
		font-weight: 350;
	}
	::v-deep .el-dialog__body {
		padding: 10px 30px 30px !important;
	}
	.dialog-footer{
		text-align: center;
	}
}
</style>
